import React from "react"
import { Styled, css } from "theme-ui"
import Layout from "../gatsby-theme-notes/components/layout"
import SEO from "gatsby-theme-blog/src/components/seo"
import BlogHomeFooter from "gatsby-theme-blog/src/components/home-footer"
import styledQuizz from "./quizz-styles"

export default props => {
  const {
    location,
    data: {
      site: {
        siteMetadata: { title, social },
      },
    },
    quizzTitle,
  } = props
  return (
    <Layout
      title={title}
      location={location}
      style={{ paddingTop: 0 }}
      {...props}
    >
      <SEO title={`${quizzTitle} - ${title}`} description="Lancez-vous !" />
      <Styled.div css={css(styledQuizz())}>
        {props.children}
        <BlogHomeFooter socialLinks={social} {...props} />
      </Styled.div>
    </Layout>
  )
}
